export default __webpack_public_path__ + "static/countryBackground-b8f0a7df39838048f4de197a48556b82.png";